// extracted by mini-css-extract-plugin
module.exports = {"historyHeader":"FlowViewOnly_historyHeader__R0mqT","flowName":"FlowViewOnly_flowName__pk3v2","wrapper":"FlowViewOnly_wrapper__1J0Lg"};